import type { IconNode } from '../types';

/**
 * @name motor-racing-helmet
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMjIgMTIuMmExMCAxMCAwIDEgMC0xOS40IDMuMmMuMi41LjggMS4xIDEuMyAxLjNsMTMuMiA1LjFjLjUuMiAxLjIgMCAxLjYtLjNsMi42LTIuNmMuNC0uNC43LTEuMi43LTEuN1oiIC8+CiAgPHBhdGggZD0ibTIxLjggMTgtMTAuNS00YTIgMi4wNiAwIDAgMSAuNy00aDkuOCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/motor-racing-helmet
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const motorRacingHelmet: IconNode = [
  [
    'path',
    {
      d: 'M22 12.2a10 10 0 1 0-19.4 3.2c.2.5.8 1.1 1.3 1.3l13.2 5.1c.5.2 1.2 0 1.6-.3l2.6-2.6c.4-.4.7-1.2.7-1.7Z',
      key: '1p03d9',
    },
  ],
  ['path', { d: 'm21.8 18-10.5-4a2 2.06 0 0 1 .7-4h9.8', key: 'w0yzsq' }],
];

export default motorRacingHelmet;
